import React from "react";
import { useLanguage } from "@/context/LanguageContext";

const OWNER_EMAIL = "malcobasilio@gmail.com";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-card" data-testid="app-footer">
      <div className="mx-auto max-w-7xl px-6 py-10">
        <div className="grid gap-8 md:grid-cols-[1.2fr_2fr]">
          {/* Brand */}
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-muted-foreground">
              {t.tagline}
            </div>
            <div className="mt-1 text-lg font-semibold tracking-tight">
              {t.brand}
            </div>
          </div>

          {/* Disclaimer */}
          <div>
            <p className="text-xs leading-relaxed text-muted-foreground">
              {t.disclaimer_long}
            </p>
          </div>
        </div>

        {/* Bottom signature line */}
        <div className="mt-8 flex flex-wrap items-center justify-between gap-3 border-t border-border pt-6">
          <p
            className="font-mono text-[10px] uppercase tracking-[0.24em] text-muted-foreground"
            data-testid="footer-copyright"
          >
            © {year} · {t.brand}
          </p>
          <p
            className="font-mono text-[10px] tracking-[0.18em] text-muted-foreground/70"
            data-testid="footer-authorship"
          >
            autoria · {OWNER_EMAIL}
          </p>
        </div>
      </div>
    </footer>
  );
}
